import { ThemeNames } from 'types/themes';

export const JOINAPP_EXPREALTY = 'https://joinapp.exprealty.com/';

export const JOIN_EXPREALTY_CA_CONTACT = '/join-exp-ca-contact';

export const JoinPageContactPages = {
  [ThemeNames.EXP_REALTY_US]: '/join-exp-us-contact',
  [ThemeNames.EXP_REALTY_CA]: '/join-exp-ca-contact',
};

export const JoinPageContactPaths = {
  [ThemeNames.EXP_REALTY_US]: '/contact',
  [ThemeNames.EXP_REALTY_CA]: '/contact-ca',
};